<script setup lang="ts">
import type { TypeDeliveryStepsData } from "@ViewPages/Main/Components/commonTypes";
import { isLastLoop }                 from "@TsUtils/helpers";
import { inject, onMounted }          from "vue";
import { MainCarousel }               from "@TsUtils/MainCarousel";

const props = <TypeDeliveryStepsData>inject('delivery_steps_data'),
    isMobileDevice = props?.device_type == 'mobile';

const mainCarousel = new MainCarousel({
    idOrClassNameCarouseEl: '#delivery-steps-carousel',
    idOrClassNameCarouselItemsEls: '#delivery-steps-carousel-item-',
    idOrClassNameIndicatorEls: '#delivery-steps-carousel-indicator-',
    data_list: props.delivery_steps_data,
    isMobileDevice: isMobileDevice,
});

onMounted(() => {
    if (isMobileDevice) {
        mainCarousel.handleCarousel();
    }
});

const carouselItemClass = [
        isMobileDevice
            ? 'hidden duration-200 ease-linear'
            : 'relative after:absolute w-30% xl:w-1/5 xl-6:w-1/6',
        'min-w-52',
        'after:border-opacity-50',
        'after:absolute after:top-0 after:right-0 after:block',
        'after:w-4 after:h-4',
        'after:border-l-transparent after:border-b-transparent',
        'after:border-[40px] after:border-solid',
    ].join(' '),
    carouselWrapperClass = [
        isMobileDevice ? 'h-72' : 'flex flex-wrap max-sm-6:justify-evenly justify-between gap-4'
    ].join(' ');
</script>

<template>
    <div class="delivery-steps__item">
        <div class="relative w-full overflow-hidden" id="delivery-steps-carousel">
            <!-- Carousel wrapper -->
            <div :class="carouselWrapperClass">
                <!-- Item -->
                <div v-for="(data, index) in props?.delivery_steps_data"
                     :key="index" :id="'delivery-steps-carousel-item-' + (+index + 1)"
                     :class="[
                         carouselItemClass,
                         (+index % 2 == 0 ? 'after:border-custom-green-600' : 'after:border-custom-orange-400'),
                         !isMobileDevice && isLastLoop(+index, props?.delivery_steps_data) ? 'max-xl-6:mr-auto' : '']"
                     @touchstart="mainCarousel.handleTouchStart"
                     @touchend="mainCarousel.handleTouchEnd"
                     @touchmove="mainCarousel.handleTouchMove">

                    <div class="delivery-steps__num absolute top-3 right-3 text-2.2xl font-medium
                                text-white z-10">
                        {{ +index + 1 }}
                    </div>

                    <div v-html="data.img_tag"></div>

                    <div class="font-medium text-xl xl:text-0.1xl break-words mb-5">
                        {{ data.title }}
                    </div>
                </div>
            </div>

            <!-- Slider indicators -->
            <div v-if="isMobileDevice"
                 class="absolute z-30 flex -translate-x-1/2 space-x-3 bottom-5 left-1/2">
                <button type="button" class="w-3 h-3 rounded-full" v-for="index in Object.keys(props?.delivery_steps_data)"
                        :aria-current="+index == 0"
                        :aria-label="'Slide' + index"
                        :id="'delivery-steps-carousel-indicator-' + (+index + 1)"
                ></button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
